import { List } from "immutable";
import * as M from "../models";

export interface AdminEmailTemplateState {
    templates: List<M.Email.EmailTemplate>;
    loadingTemplate: M.Generic.ItemLoadingState;
    loadingTemplates: boolean;
    loadingTypes: boolean;
    types: List<M.Email.EmailTemplateType>;
}

export const initialState: AdminEmailTemplateState = {
    templates: List(),
    loadingTemplate: {},
    loadingTemplates: true,
    loadingTypes: true,
    types: List(),
};



// WEBPACK FOOTER //
// ./src/store/AdminEmailTemplateState.ts